import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { map, take } from "rxjs/operators";
import {
  SessionStorageKey,
  SessionStorageState,
  SsoAccountFacade,
  SsoAccountData,
  AgreementSigningStatus
} from "common";
import { IdentityNavigationService } from "../../features/identity-verification/services/identity-navigation.service";

@Injectable({
  providedIn: "root",
})
export class LoanAgreementSignedGuard implements CanActivate {
  constructor(
    private identityNavigationService: IdentityNavigationService,
    private ssoAccountFacade: SsoAccountFacade
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (SessionStorageState.get(SessionStorageKey.AccountAgreementViewed)) {
      return true;
    }
    return    this.ssoAccountFacade.getCurrentSsoAccount$()
    .pipe(
      take(1),
      map((currentState: SsoAccountData) => {
        const loanToSign = currentState.loans?.find(l => l.agreementState?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser || l.renewalApplication?.agreementSigningStatus === AgreementSigningStatus.PendingCurrentUser);
        if (loanToSign) {
          this.identityNavigationService.signLoanAgreement({ loanId: loanToSign.loanId })
          return false;
        }
        return true;
      })
    );
  }
}


